export default __webpack_public_path__ + "static/media/twitter2-icon.30fd4f47.svg";